import { LoginStateEnum, useAuth } from 'modules/auth/auth.context';
import { LoginForm } from 'modules/auth/login';
import { Redirect } from 'react-router-dom';
export function LoginPage() {
  const { loginState } = useAuth();

  switch (loginState) {
    case LoginStateEnum.LOADING:
      return null;
    case LoginStateEnum.LOGGED_IN:
      return <Redirect to="/" />;
    case LoginStateEnum.LOGGED_OUT:
      return <LoginForm />;
  }
}
